export default {
  preloader: false,
  params: {
    year_month: null
  }
};



// WEBPACK FOOTER //
// ./src/modules/receivable/state.js